import './ObjectTabs.scss';
import { useRef } from 'react';

export default function ObjectTabs({ activeTab, ariaLabel = 'Navigation de l’objet', onChange, tabs = [] }) {
  const tabRefs = useRef({});

  const handleKeyDown = (event, index) => {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    event.preventDefault();
    let nextIndex = index;
    if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;
    const nextTab = tabs[nextIndex];
    onChange(nextTab.key);
    tabRefs.current[nextTab.key]?.focus();
  };

  return (
    <div className="object-tabs" role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab, index) => (
        <button
          ref={(element) => { tabRefs.current[tab.key] = element; }}
          id={`object-tab-${tab.key}`}
          aria-controls={`object-panel-${tab.key}`}
          aria-selected={activeTab === tab.key}
          className={`object-tabs__button ${tab.secondary ? 'object-tabs__button--secondary' : ''} ${activeTab === tab.key ? 'object-tabs__button--active' : ''}`}
          key={tab.key}
          onClick={() => onChange(tab.key)}
          onKeyDown={(event) => handleKeyDown(event, index)}
          role="tab"
          tabIndex={activeTab === tab.key ? 0 : -1}
          type="button"
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
